import React from 'react';
import { Input } from '../ui/Input';
import { TextArea } from '../ui/TextArea';
import { Checkbox } from '../ui/Checkbox';
import { Button } from '../ui/Button';
import { TrashIcon } from 'lucide-react';
import { formatCurrency, formatPercent, calculateProfitMargin } from '../../utils/calculations';
interface LineItemRowProps {
  index: number;
  description: string;
  quantity: number;
  price: number;
  jobCost?: number;
  isTaxable: boolean;
  onDescriptionChange: (value: string) => void;
  onQuantityChange: (value: number) => void;
  onPriceChange: (value: number) => void;
  onJobCostChange: (value: number | undefined) => void;
  onTaxableChange: (value: boolean) => void;
  onRemove: () => void;
  canRemove: boolean;
}
export function LineItemRow({
  index,
  description,
  quantity,
  price,
  jobCost,
  isTaxable,
  onDescriptionChange,
  onQuantityChange,
  onPriceChange,
  onJobCostChange,
  onTaxableChange,
  onRemove,
  canRemove
}: LineItemRowProps) {
  const lineTotal = quantity * price;
  const profitMargin = calculateProfitMargin(price, jobCost);
  return <div className="bg-gray-50 rounded-lg p-4 space-y-4" data-id="element-139">
      <div className="flex items-start justify-between gap-4" data-id="element-140">
        <span className="text-sm font-medium text-gray-500 mt-2" data-id="element-141">
          #{index + 1}
        </span>
        <div className="flex-1" data-id="element-142">
          <TextArea placeholder="Description" value={description} onChange={e => onDescriptionChange(e.target.value)} className="min-h-[60px]" data-id="element-143" />
        </div>
        {canRemove && <Button variant="ghost" size="sm" onClick={onRemove} className="text-red-600 hover:text-red-700 hover:bg-red-50" aria-label="Remove line item" data-id="element-144">
            <TrashIcon className="w-4 h-4" data-id="element-145" />
          </Button>}
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-id="element-146">
        <Input label="Quantity" type="number" min="1" step="1" value={quantity} onChange={e => onQuantityChange(Math.max(1, parseInt(e.target.value) || 1))} data-id="element-147" />
        <Input label="Unit Price" type="number" min="0" step="0.01" value={price} onChange={e => onPriceChange(Math.max(0, parseFloat(e.target.value) || 0))} data-id="element-148" />
        <Input label="Job Cost (optional)" type="number" min="0" step="0.01" value={jobCost ?? ''} onChange={e => {
        const val = e.target.value;
        onJobCostChange(val === '' ? undefined : Math.max(0, parseFloat(val) || 0));
      }} data-id="element-149" />
        <div className="flex flex-col justify-end" data-id="element-150">
          <Checkbox label="Taxable" checked={isTaxable} onChange={e => onTaxableChange(e.target.checked)} data-id="element-151" />
        </div>
      </div>

      <div className="flex items-center justify-between pt-2 border-t border-gray-200" data-id="element-152">
        <div className="flex items-center gap-4 text-sm" data-id="element-153">
          <span className="text-gray-500" data-id="element-154">Line Total:</span>
          <span className="font-semibold text-gray-900" data-id="element-155">
            {formatCurrency(lineTotal)}
          </span>
          {profitMargin !== undefined && <>
              <span className="text-gray-300" data-id="element-156">|</span>
              <span className="text-gray-500" data-id="element-157">Margin:</span>
              <span className={`font-medium ${profitMargin >= 0 ? 'text-green-600' : 'text-red-600'}`} data-id="element-158">
                {formatPercent(profitMargin)}
              </span>
            </>}
        </div>
      </div>
    </div>;
}